import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioGroup } from '../ReduxFormField';
import { HorizontalFormControl, InfoLabel } from '../index';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import InfoButton from '../InfoButton/InfoButton';

const infoButtonMessages = {
  insurerCode:
    'Unique Identifier applied behind the scenes, required for Brand set up (cannot be edited)',
  brandContact: 'Reference for Brand contract (optional)',
  maxCommission:
    'Set Maximum brokerage allowed - will apply to new schemes; note this is only max limit, you can adjust the commission per scheme level accordingly, permitting it is under this amount',
  carryBroker:
    " Determines whether Brokers can hold client money (make payment on account, by cash or cheque), also needs to be agreed on an individual Broker basis (within the broker set up 'Hold client money')",
};

class EditDetailsForm extends Component {
  getFieldName = () => {
    const { isNew, context } = this.props;
    if (context === 'brandDetails') {
      return 'data.id';
    }
    if (context === 'organisation') {
      return isNew ? 'data.attributes.code' : 'data.id';
    }
  };

  render() {
    const { isNew, onInputChange } = this.props;
    return (
      <div>
        <Row>
          <Col xs={12}>
            <Field
              labelSize={4}
              label="Insurer Code"
              name={this.getFieldName()}
              infoButton={<InfoButton content={infoButtonMessages.insurerCode} />}
              component={isNew ? HorizontalFormControl : InfoLabel}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Field
              labelSize={4}
              label="Name"
              name="data.attributes.name"
              onChange={onInputChange}
              component={HorizontalFormControl}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Field
              labelSize={4}
              label="Agreement Number"
              name={'data.attributes.agreement_number'}
              onChange={onInputChange}
              infoButton={<InfoButton content={infoButtonMessages.brandContact} />}
              component={HorizontalFormControl}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Field
              labelSize={4}
              percentage={true}
              label="Max Brokerage"
              name={'data.attributes.max_commission'}
              onChange={onInputChange}
              infoButton={<InfoButton content={infoButtonMessages.maxCommission} />}
              component={HorizontalFormControl}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Field
              name={'data.attributes.carry_broker_risk'}
              label="Carry Broker Risk"
              component={RadioGroup}
              onChange={onInputChange}
              infoButton={<InfoButton content={infoButtonMessages.carryBroker} />}
              inline
              labelSize={4}
              options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

EditDetailsForm.propTypes = {
  context: PropTypes.string.isRequired,
};

export default EditDetailsForm;
